"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6282],{

/***/ 43046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


const Circle = (param)=>/*#__PURE__*/ {
    let { style ={} , color , diameter , className =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        height: diameter,
        width: diameter,
        className: className,
        style: style,
        role: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
            cx: "50%",
            cy: "50%",
            r: "45%",
            strokeWidth: "3",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Circle);


/***/ }),

/***/ 88177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ GlimmerOffset; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45602);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);



var GlimmerOffset;
(function(GlimmerOffset) {
    GlimmerOffset["XXS"] = "100px";
    GlimmerOffset["XS"] = "200px";
    GlimmerOffset["SM"] = "400px";
    GlimmerOffset["MD"] = "700px";
    GlimmerOffset["LG"] = "1200px";
    GlimmerOffset["XL"] = "1900px";
})(GlimmerOffset || (GlimmerOffset = {}));
const Glimmer = (param)=>/*#__PURE__*/ {
    let { height ="100%" , width ="100%" , offset =GlimmerOffset.SM , backgroundColor =_c10h_colors__WEBPACK_IMPORTED_MODULE_2__.gray100 , waveColor =_c10h_colors__WEBPACK_IMPORTED_MODULE_2__.gray50 , style ={}  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            height,
            width,
            ...style,
            "--glimmer-offset": offset,
            "--shimmer-bg": backgroundColor,
            "--shimmer-wave": waveColor
        },
        className: "shimmer br1 minh4"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Glimmer));


/***/ }),

/***/ 85208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _components_ErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37495);
/* harmony import */ var _components_Label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15061);
/* harmony import */ var _utils_commonStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49143);
/* harmony import */ var _utils_randomId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53725);






const TextInput = (param)=>{
    let { className , placeholder , onChange , onEnter , onBlur , icon , label , setValidation , errorMsg , ariaLabel , defaultValue , autoFocus =false , autoComplete ="off" , inputValue , ...props } = param;
    var _ref_current;
    const [focused, setFocused] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const isLabelSmall = focused || Boolean((_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.value);
    const isBadInput = typeof errorMsg === "string";
    const [inputId, setInputId] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [labelId, setLabelId] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setInputId((0,_utils_randomId__WEBPACK_IMPORTED_MODULE_5__/* .randomId */ .k)());
        setLabelId((0,_utils_randomId__WEBPACK_IMPORTED_MODULE_5__/* .randomId */ .k)());
    }, []);
    const handleOnBlur = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        setFocused(false);
        setValidation === null || setValidation === void 0 ? void 0 : setValidation(true);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    }, [
        setValidation,
        onBlur
    ]);
    const onInputChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((e)=>{
        onChange(e.target.value);
    }, [
        onChange
    ]);
    const onKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((e)=>{
        if (e.key === "Enter") {
            if (!errorMsg) {
                onEnter === null || onEnter === void 0 ? void 0 : onEnter(e.currentTarget.value);
            }
            setValidation === null || setValidation === void 0 ? void 0 : setValidation(true);
        }
    }, [
        errorMsg,
        onEnter,
        setValidation
    ]);
    const setInputOpacity = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        return isLabelSmall && placeholder ? "opacity-1" : !label || !placeholder ? "opacity-1" : "opacity-0";
    }, [
        isLabelSmall,
        label,
        placeholder
    ]);
    const handleOnFocus = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>setFocused(true), []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pos-r w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                ...props,
                "data-cy": "",
                className: "".concat(_utils_commonStyles__WEBPACK_IMPORTED_MODULE_4__/* .inputStyles.wrapper */ .T.wrapper, " ").concat(borderStyles(focused, isBadInput), " ").concat(className || "", " ").concat(label ? "pt7" : "", " ").concat(inputBgColor(focused, isBadInput)),
                children: [
                    icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "pr2 fs26 fs22-sm ".concat(icon, " ").concat(iconColor(focused)),
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Label__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        label: label,
                        id: labelId,
                        htmlFor: inputId,
                        isLabelSmall: isLabelSmall
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        onChange: onInputChange,
                        onFocus: handleOnFocus,
                        onBlur: handleOnBlur,
                        value: inputValue && inputValue,
                        id: inputId,
                        ref: ref,
                        "aria-label": ariaLabel,
                        "aria-labelledby": labelId,
                        className: "".concat(_utils_commonStyles__WEBPACK_IMPORTED_MODULE_4__/* .inputStyles.input */ .T.input, " ").concat(label && "top-1.5", " ").concat(setInputOpacity()),
                        placeholder: placeholder,
                        onKeyDown: onKeyDown,
                        defaultValue: defaultValue,
                        // eslint-disable-next-line jsx-a11y/no-autofocus
                        autoFocus: autoFocus,
                        // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type '"data-cy"' can't be used to index type '{ defaultChecked?: boolean | undefined; suppressContentEditableWarning?: boolean | undefined; suppressHydrationWarning?: boolean | undefined; accessKey?: string | undefined; contentEditable?: Booleanish | ... 1 more ... | undefined; ... 245 more ...; onTransitionEndCapture?: TransitionEventHandler<...> | undefined; }'.
                        "data-cy": props["data-cy"],
                        autoComplete: autoComplete
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                msg: errorMsg
            })
        ]
    });
};
const borderStyles = (focused, error)=>error ? "border-2 border-solid border-error-700" : focused ? "border-blue-500 border-2 border-solid" : "border-2 border-solid border-gray-100";
const iconColor = (focused)=>focused ? "text-blue-500" : "text-gray400";
const inputBgColor = (focused, error)=>error ? "bg-white" : focused ? "bg-blue-100" : "bg-gray-100";
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(TextInput));


/***/ }),

/***/ 37495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


const ErrorMessage = (param)=>{
    let { msg  } = param;
    if (!msg) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: "text-xs mt-1 text-error-700",
        children: msg
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ErrorMessage));


/***/ }),

/***/ 15061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _utils_commonStyles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49143);



const Label = (param)=>{
    let { label , id , htmlFor , isLabelSmall  } = param;
    if (!label) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        className: "".concat(_utils_commonStyles__WEBPACK_IMPORTED_MODULE_2__/* .inputStyles.label */ .T.label, " ").concat(isLabelSmall ? "top-1 sm:top-2 scale-[.7]" : "top-3 sm:top-4 scale-100"),
        children: label
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Label));


/***/ }),

/***/ 49143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ inputStyles; }
/* harmony export */ });
const inputStyles = {
    wrapper: "box-border flex items-center rounded-xl w-full px-4 py-3 sm:py-4 pos-r ease-in-out duration-200 rounded-[10px]",
    label: "absolute text-base pl-0.5 font-i ease-in-out duration-150 text-gray600 cursor-text origin-top-left",
    input: "text-base leading-normal py-0 outline-0 border-0 w-full pos-r bg-transparent placeholder:text-gray400 text-gray800"
};


/***/ }),

/***/ 53725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ randomId; }
/* harmony export */ });
const randomId = ()=>"carbon-".concat(Math.random().toString(36).slice(2, 11));


/***/ }),

/***/ 5621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v5_NextImage; }
});

// UNUSED EXPORTS: cloudflareLoader

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(30164);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/useV5ImgSrc.tsx
var useV5ImgSrc = __webpack_require__(52299);
;// CONCATENATED MODULE: ./src/utils/nextImageSource.ts

const nextImageSource = function(src) {
    let extension = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "jpg";
    const path = src[0] === "/" ? src : "/".concat(src);
    return "".concat(useV5ImgSrc/* V5_ROOT */.M7).concat(path, ".").concat(extension);
};
/* harmony default export */ var utils_nextImageSource = (nextImageSource);

// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
;// CONCATENATED MODULE: ./src/components/v5/NextImage.tsx





const cloudflareloaderRootUrl = "https://carbonhealth.com";
// @ts-expect-error TS7006: Parameter 'src' implicitly has an 'any' type.
const normalizeSrc = (src)=>src[0] === "/" ? src.slice(1) : src;
const cloudflareLoader = (param)=>{
    let { src , width , quality  } = param;
    const params = [
        "width=".concat(width)
    ];
    if (quality) {
        params.push("quality=".concat(quality));
    }
    const paramsString = params.join(",");
    return "".concat(cloudflareloaderRootUrl || "", "/cdn-cgi/image/").concat(paramsString, "/").concat(normalizeSrc(src));
};
/**
 @deprecated use `<Image/>` from `@components/Image` or direct import from `next/image` instead
 */ const NextImage = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { src , extension ="jpg" , className , ...rest } = param;
    const layoutClass = "layout" in rest && rest.layout === "fill" ? "h100p obfc" : "";
    const classes = "pos-a top0 right0 bottom0 left0 minw100p minh100p ".concat(layoutClass, " ").concat(className || "");
    const srcStr = src;
    // isFullPath = true : if an external
    const isFullPath = srcStr.startsWith("http");
    const source = isFullPath ? src : utils_nextImageSource(srcStr, extension);
    const shouldUseLoader = !_constants/* dev */.WI && !_constants/* isCI */.yg || cloudflareloaderRootUrl;
    if (extension === "svg") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            alt: rest.alt || source,
            className: className,
            src: source,
            ...rest
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        ...rest,
        ...shouldUseLoader && {
            loader: cloudflareLoader
        },
        priority: !!_constants/* isCI */.yg || rest.priority,
        className: classes,
        src: _constants/* isCI */.yg && isFullPath ? "https://via.placeholder.com/".concat(rest.width || 100, "x").concat(rest.height || 100, ".png") : source
    });
});
NextImage.displayName = "NextImage";
/* harmony default export */ var v5_NextImage = (NextImage);


/***/ }),

/***/ 40603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useDisclosure; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);

const useDisclosure = function() {
    let initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialValue);
    const close = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>setState(false), []);
    const open = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>setState(true), []);
    const toggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>setState((state)=>!state), []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({
            close,
            open,
            toggle,
            set: setState,
            isOpen: state,
            isClosed: !state
        }), [
        close,
        open,
        toggle,
        state,
        setState
    ]);
};


/***/ }),

/***/ 75290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oZ": function() { return /* binding */ QueryStatus; },
  "co": function() { return /* binding */ useQueryController; }
});

// UNUSED EXPORTS: mergeQueryLifecycleState

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
;// CONCATENATED MODULE: ./src/hooks/useCache.ts

/**
 * Creates a small cache for a frequently changing query.
 * Does not persist between page changes, refreshes, or between various calls to `useCache`.
 * Only works for a single instance of calling `useCache`.
 */ const useCache = ()=>{
    const [cache, setCache] = (0,react.useState)({});
    const getCachedValue = (0,react.useCallback)((key)=>({
            isHit: key in cache,
            value: cache[key]
        }), [
        cache
    ]);
    const updateCache = (0,react.useCallback)((key, value)=>{
        setCache((state)=>({
                ...state,
                [key]: value
            }));
    }, []);
    return {
        getCachedValue,
        updateCache
    };
};

;// CONCATENATED MODULE: ./src/hooks/useQueryController.ts


var QueryStatus;
(function(QueryStatus) {
    QueryStatus["SUCCESS"] = "SUCCESS";
    QueryStatus["LOADING"] = "LOADING";
    QueryStatus["ERROR"] = "ERROR";
    QueryStatus["WAITING"] = "WAITING";
})(QueryStatus || (QueryStatus = {}));
const getQueryStatusProperties = (status)=>({
        status,
        isInitiated: status !== QueryStatus.WAITING,
        isSettled: status === QueryStatus.SUCCESS || status === QueryStatus.ERROR,
        isLoading: status === QueryStatus.LOADING
    });
/**
 * Provides life-cycle updates and a small caching layer for an async data fetch.
 * @param fn async data fetch function
 * @param ifRejectedValue value for `data` if the async fn rejects
 * @param initialValue value for `data` before the first call to `fn` completes.
 * @param skip if true, `fn` will not execute
 * @param cacheKey serialized function arguments for lookup to prevent unnecessary calls to `fn`
 */ const useQueryController = (param)=>{
    let { fn , initialValue , ifRejectedValue =initialValue , skip =false , cacheKey  } = param;
    const { getCachedValue , updateCache  } = useCache();
    const [state, setState] = (0,react.useState)({
        data: initialValue,
        ...getQueryStatusProperties(QueryStatus.WAITING)
    });
    const cached = (0,react.useMemo)(()=>{
        const cacheCheck = getCachedValue(cacheKey);
        return cacheCheck.isHit ? {
            ...getQueryStatusProperties(QueryStatus.SUCCESS),
            data: cacheCheck.value
        } : null;
    }, [
        cacheKey,
        getCachedValue
    ]);
    const loading = (0,react.useMemo)(()=>{
        return {
            ...state,
            ...getQueryStatusProperties(QueryStatus.LOADING)
        };
    }, [
        state
    ]);
    const rejected = (0,react.useMemo)(()=>{
        return {
            ...getQueryStatusProperties(QueryStatus.ERROR),
            data: ifRejectedValue
        };
    }, [
        ifRejectedValue
    ]);
    if (skip || state.status === QueryStatus.LOADING) {
        return state;
    } else if (cached) {
        return cached;
    } else {
        fn().then((res)=>{
            updateCache(cacheKey, res);
            setState({
                ...getQueryStatusProperties(QueryStatus.SUCCESS),
                data: res
            });
        }).catch(()=>{
            setState(rejected);
        });
        setState(loading);
        return loading;
    }
};
const mergeQueryLifecycleState = function() {
    for(var _len = arguments.length, queries = new Array(_len), _key = 0; _key < _len; _key++){
        queries[_key] = arguments[_key];
    }
    const status = queries.every((query)=>query.status === QueryStatus.WAITING) ? QueryStatus.WAITING : queries.every((query)=>query.status === QueryStatus.SUCCESS || query.status === QueryStatus.WAITING) ? QueryStatus.SUCCESS : queries.some((query)=>query.status === QueryStatus.ERROR) ? QueryStatus.ERROR : QueryStatus.LOADING;
    return {
        status,
        isInitiated: status !== QueryStatus.WAITING,
        isSettled: status === QueryStatus.SUCCESS || status === QueryStatus.ERROR,
        isLoading: status === QueryStatus.LOADING
    };
};


/***/ }),

/***/ 8764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JQ": function() { return /* binding */ getReadableSlotTime; },
  "u5": function() { return /* binding */ isEvenHour; },
  "H5": function() { return /* binding */ useReadableSlotTime; }
});

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(7037);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/constants/MsMap.ts
var MsMap = __webpack_require__(56776);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(50995);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
;// CONCATENATED MODULE: ./src/utils/getTimezone.ts


const getTimezone = ()=>{
    try {
        return moment_timezone_default().tz.guess();
    } catch (err) {
        return _constants/* laTimezone */.$A; // could also be something like moment.tz.names()[0];
    }
};
/* harmony default export */ var utils_getTimezone = (getTimezone);

;// CONCATENATED MODULE: ./src/hooks/useReadableSlotTime.ts





const isEvenHour = (msTime)=>msTime % MsMap/* MsMap.ONE_HOUR */.I.ONE_HOUR === 0;
const getReadableSlotTime = (param)=>{
    let { time , t , timezone , isLowerCase =false , withNext =false , withoutHour =false  } = param;
    if (!time) return null;
    const sameDay = "".concat(t("Today"));
    const nextDay = "".concat(t("Tomorrow"));
    const lastWeek = "".concat(t("Last"));
    const actualMoment = moment_default()(time).tz(timezone || utils_getTimezone());
    const timeFormat = isEvenHour(actualMoment.valueOf()) ? "ha" : "h:mma";
    const formatWithHour = {
        sameDay: "[".concat(sameDay, "] \xb7 ").concat(timeFormat),
        nextDay: "[".concat(nextDay, "] \xb7 ").concat(timeFormat),
        nextWeek: "MMM DD \xb7 ".concat(timeFormat),
        lastWeek: "[".concat(lastWeek, "] \xb7 dddd"),
        sameElse: "MMM DD \xb7 ".concat(timeFormat)
    };
    const formatWithoutHour = {
        sameDay: "[".concat(sameDay, "], MMMM D"),
        nextDay: "[".concat(nextDay, "], MMMM D"),
        nextWeek: "dddd, MMMM D",
        lastWeek: "[".concat(lastWeek, "] dddd"),
        sameElse: "dddd, MMMM D"
    };
    const formattedTime = actualMoment.calendar(null, withoutHour ? formatWithoutHour : formatWithHour);
    const maybeNext = withNext ? t("Next: ") : "";
    const maybeLowerCased = isLowerCase ? formattedTime.toLowerCase() : formattedTime;
    const final = "".concat(maybeNext).concat(maybeLowerCased);
    return final;
};
const useReadableSlotTime = function(time) {
    let { isLowerCase , withNext , withoutHour , timezone  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        isLowerCase: false,
        withNext: false,
        withoutHour: false
    };
    const { t  } = (0,i18n/* useTranslation */.$G)();
    return (0,react.useMemo)(()=>getReadableSlotTime({
            time,
            t,
            timezone,
            isLowerCase,
            withNext,
            withoutHour
        }), [
        time,
        t,
        timezone,
        isLowerCase,
        withNext,
        withoutHour
    ]);
};


/***/ }),

/***/ 43612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ BookingStep; }
/* harmony export */ });
var BookingStep;
(function(BookingStep) {
    BookingStep["ACCOUNT_CREATION"] = "account_creation";
    BookingStep["ACCOUNT_SELECTION"] = "account_selection";
    BookingStep["APPOINTMENT_CONFIRMATION"] = "appt_confirmation";
    BookingStep["LOCATION_SELECTION"] = "location_selection";
    BookingStep["REASON_SELECTION"] = "reason_selection";
    BookingStep["TIME_SELECTION"] = "time_selection";
    BookingStep["TIME_RESELECTION"] = "time_reselection";
    BookingStep["RESCHEDULING"] = "rescheduling";
    BookingStep["RESCHEDULING_CONFIRMATION"] = "rescheduling_confirmation";
})(BookingStep || (BookingStep = {}));


/***/ }),

/***/ 71561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getMilesAway; }
/* harmony export */ });
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95832);

/**
 * Get the number of miles between the user's location and the clinic location.
 */ function getMilesAway(userLocation, location) {
    const latitude = location.address.latitude;
    const longitude = location.address.longitude;
    return userLocation && latitude && longitude ? (0,_services_api__WEBPACK_IMPORTED_MODULE_0__/* .getGeoDistance */ .tl)(userLocation.x, userLocation.y, latitude, longitude) : undefined;
}


/***/ }),

/***/ 57974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
/* harmony import */ var _utils_mediaQueries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11621);
/* harmony import */ var _utils_noOp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47597);



const BreakpointMap = {
    xs: 480,
    sm: 767,
    md: 992,
    lg: 1024,
    lgxl: 1200,
    xl: 1440
};
/**
 * xs: 480
 * sm: 767
 * md: 992
 * lg: 1024
 * lgxl: 1200
 * xl: 1440
 * @returns Boolean, whether or not the screen size matches the query
 */ const useMediaQuery = (bp, options)=>{
    const min = (options === null || options === void 0 ? void 0 : options.min) || false;
    const height = (options === null || options === void 0 ? void 0 : options.isHeight) || false;
    const dimension = height ? "height" : "width";
    const queryString = min ? "(min-".concat(dimension, ": ").concat(BreakpointMap[bp], "px)") : "(max-".concat(dimension, ": ").concat(BreakpointMap[bp], "px)");
    const [matches, setMatches] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (typeof matchMedia !== "undefined") {
            const mediaQueryList = matchMedia(queryString);
            setMatches(mediaQueryList.matches);
            const listener = (e)=>setMatches(e.matches);
            (0,_utils_mediaQueries__WEBPACK_IMPORTED_MODULE_1__/* .addListenerSafe */ .D)(mediaQueryList, listener);
            return ()=>{
                (0,_utils_mediaQueries__WEBPACK_IMPORTED_MODULE_1__/* .removeListenerSafe */ .n)(mediaQueryList, listener);
            };
        }
        return _utils_noOp__WEBPACK_IMPORTED_MODULE_2__/* .noOp */ .E;
    }, [
        queryString
    ]);
    return matches;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMediaQuery);


/***/ }),

/***/ 52221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lv": function() { return /* binding */ s3ImageSource; },
/* harmony export */   "PO": function() { return /* binding */ S3Image; }
/* harmony export */ });
/* unused harmony export useS3ImgSrc */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _components_common_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93932);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40367);




const useS3ImgSrc = function(id) {
    let density = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    const { imgExt  } = (0,_store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    return "".concat(_components_common_constants__WEBPACK_IMPORTED_MODULE_2__/* .s3ImagesRootUrl */ .Sd, "/").concat(id, "/").concat(density, "x.").concat(imgExt);
};
const S3ImageComponent = (param)=>/*#__PURE__*/ {
    let { id , density , className , alt , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: useS3ImgSrc(id, density),
        className,
        alt,
        ...props
    });
};
S3ImageComponent.displayName = "S3ImageComponent";
const S3Image = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(S3ImageComponent);
const s3ImageSource = function(id) {
    let ext = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "jpg", density = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    return "".concat(_components_common_constants__WEBPACK_IMPORTED_MODULE_2__/* .s3ImagesRootUrl */ .Sd, "/").concat(id, "/").concat(density, "x.").concat(ext);
};


/***/ }),

/***/ 52299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M7": function() { return /* binding */ V5_ROOT; },
/* harmony export */   "dZ": function() { return /* binding */ V5Image; },
/* harmony export */   "eH": function() { return /* binding */ useV5ImgSrc; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40367);



const V5_ROOT = "/static/img/v5";
const useV5ImgSrc = function(src) {
    let isSvg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, imgExt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    const { imgExt: imgExtConfig  } = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    // @ts-expect-error TS2322: Type 'null' is not assignable to type 'string'.
    if (!src) return null;
    return "".concat(V5_ROOT).concat(src[0] === "/" ? "" : "/").concat(src, ".").concat(isSvg ? "svg" : imgExt || imgExtConfig);
};
// eslint-disable-next-line react/display-name
const V5Image = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo((param)=>// @ts-expect-error TS2345: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
/*#__PURE__*/ {
    let { src , isSvg , alt , imgExt ="" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: useV5ImgSrc(src, isSvg, imgExt),
        alt: alt || "",
        ...props
    });
});


/***/ }),

/***/ 91309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ compact; }
/* harmony export */ });
const valIsNotFalsy = (val)=>Boolean(val);
const compact = (list)=>list.filter(valIsNotFalsy);


/***/ }),

/***/ 11621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ addListenerSafe; },
/* harmony export */   "n": function() { return /* binding */ removeListenerSafe; }
/* harmony export */ });
/**
 * Safe wrapper around mediaQueryList.addEventListener(), because it's not supported by
 * Safari versions < 14.
 */ function addListenerSafe(mql, listener) {
    if (mql.addEventListener) {
        mql.addEventListener("change", listener);
    } else {
        mql.addListener(listener);
    }
}
/**
 * Safe wrapper around mediaQueryList.removeEventListener(), because it's not supported by
 * Safari versions < 14.
 */ function removeListenerSafe(mql, listener) {
    if (mql.removeEventListener) {
        mql.removeEventListener("change", listener);
    } else {
        mql.removeListener(listener);
    }
}


/***/ }),

/***/ 47597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ noOp; }
/* harmony export */ });
/** A single no-op function. This single instance is useful mainly for callback
 * props so that react doesn't see new functions and re-render... but there's a tiny
 * performance boost for using it in other cases too.
 */ function noOp() {
/* Intentionally empty */ }


/***/ }),

/***/ 40248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CD": function() { return /* binding */ getStartOfDay; },
/* harmony export */   "P": function() { return /* binding */ checkIfSameDay; },
/* harmony export */   "Si": function() { return /* binding */ isInTimeRange; },
/* harmony export */   "gi": function() { return /* binding */ getOpenTime; },
/* harmony export */   "us": function() { return /* binding */ getEndOfDay; }
/* harmony export */ });
/* unused harmony export isInRange */
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50995);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_common_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93932);
/* harmony import */ var _constants_MsMap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56776);



const twentyFourHrtoAmPm = (time)=>{
    const chars = Array.from(time);
    const indexOfColon = chars.indexOf(":");
    const twentyFourHour = parseInt(chars.splice(0, indexOfColon).join(""));
    const minutes = chars.splice(indexOfColon - 1).join("");
    const showMinutes = minutes !== "00";
    const isPM = twentyFourHour > 12;
    const hour = twentyFourHour - (isPM ? 12 : 0);
    return "".concat(hour).concat(showMinutes ? ":".concat(minutes) : "").concat(isPM ? "pm" : "am");
};
const isInRange = (num, start, end)=>{
    return start <= num && num <= end;
};
const isInTimeRange = function() {
    let startTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now(), endTime = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : startTime + _constants_MsMap__WEBPACK_IMPORTED_MODULE_2__/* .MsMap.ONE_HOUR */ .I.ONE_HOUR;
    const now = Date.now();
    return isInRange(now, startTime, endTime);
};
const getOpenTime = (i18n, location, specialtyId)=>{
    var _location_specialties_specialtyId, _soonestOpenDay_timeBlock;
    const hours = specialtyId ? (_location_specialties_specialtyId = location.specialties[specialtyId]) === null || _location_specialties_specialtyId === void 0 ? void 0 : _location_specialties_specialtyId.hours : location.hours;
    const closedReturnValue = {
        timeString: i18n.t("Hours unknown")
    };
    if (!hours) return closedReturnValue;
    const now = moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()().tz(location.timezone || _components_common_constants__WEBPACK_IMPORTED_MODULE_1__/* .laTimezone */ .$A);
    const _time = now.format("HH:mm");
    const soonestOpenDay = Array(60).fill(null)// @ts-expect-error TS2345: Argument of type '(acc: { day: Moment; timeBlock: RootStateTimeBlock; diff: number; }, _next: any, i: number) => false | { day: Moment; timeBlock: RootStateTimeBlock; diff: number; } | undefined' is not assignable to parameter of type '(previousValue: { day: Moment; timeBlock: RootStateTimeBlock; diff: number; }, currentValue: any, currentIndex: number, array: any[]) => { day: Moment; timeBlock: RootStateTimeBlock; diff: number; }'.
    .reduce((acc, _next, i)=>{
        if (acc) {
            return acc;
        }
        const _day = now.add(i, "days");
        const timeBlock = hours.find((block)=>block.day.toString() === _day.format("e"));
        const isAfterClosingToday = i === 0 && timeBlock && _time >= timeBlock.to;
        return timeBlock && !isAfterClosingToday && {
            day: _day,
            timeBlock,
            diff: i
        };
    }, null);
    if (!soonestOpenDay || !((_soonestOpenDay_timeBlock = soonestOpenDay.timeBlock) === null || _soonestOpenDay_timeBlock === void 0 ? void 0 : _soonestOpenDay_timeBlock.to) || _components_common_constants__WEBPACK_IMPORTED_MODULE_1__/* .isCI */ .yg) return closedReturnValue;
    const { timeBlock , timeBlock: { to , from  } , diff , day  } = soonestOpenDay;
    const isOpenToday = diff === 0;
    const isBeforeOpeningToday = _time < from && isOpenToday;
    const isOpenNow = isOpenToday && !isBeforeOpeningToday;
    const time = twentyFourHrtoAmPm(isBeforeOpeningToday ? from : isOpenToday ? to : from);
    const timeString = isBeforeOpeningToday ? i18n.t("Opens {{time}} today", {
        time
    }) : isOpenNow ? i18n.t("until {{time}}", {
        time
    }) : diff === 1 ? i18n.t("Opens {{time}} tomorrow", {
        time
    }) : diff < 7 ? i18n.t("Opens {{time}} {{dayOfWeek}}", {
        time,
        dayOfWeek: day.format("ddd")
    }) : i18n.t("Opens {{time}} {{date}}", {
        time,
        date: day.format("MMM D")
    });
    return {
        timeString,
        isOpenNow,
        isBeforeOpeningToday,
        timeBlock,
        daysFromToday: diff
    };
};
const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const checkIfSameDay = function(time1, time2) {
    let timezone = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : userTimezone;
    return moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(time1).tz(timezone).isSame(time2, "day");
};
// ref: https://stackoverflow.com/a/36041365/263050
const getEndOfDay = (millis, timezone)=>{
    const m = moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(millis);
    return +m.clone().tz(timezone).endOf("day").utc();
};
const getStartOfDay = (millis, timezone)=>{
    const m = moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(millis);
    return +m.clone().tz(timezone).startOf("day").utc();
};


/***/ })

}]);